import * as React from "react";
import { Link } from "react-router-dom";
import "./SideBar.css";

interface Props {
    history: any;
    user: any;
    visible: boolean;
    signInCreateUser({ prompt }: { prompt: true }): Promise<void>;
    signOutUser(event: any): Promise<void>;
    hideSidebar(event: any): void;
}
const SideBar = ({ history, user, visible, signInCreateUser, signOutUser, hideSidebar, children }: Props & JSX.ElementChildrenAttribute) =>
    <div className="pushable">
        <div className={`ui inverted vertical labeled icon ui overlay left animating thin ${visible ? "visible" : ""} sidebar menu`} >
            {SidebarMenu({ history, user, visible, signInCreateUser, signOutUser, hideSidebar })}
        </div >
        <div className={`pusher ${visible ? "dimmed" : ""}`} onClick={visible ? hideSidebar : () => undefined}>{children}</div>
    </div >

const SidebarMenu = ({ history, user, visible, signInCreateUser, signOutUser, hideSidebar }: Props) => {
    if (user.id) {
        return (
            <div>
                <Link to={'/following/'} className="item" onClick={visible ? hideSidebar : () => undefined}>
                    <i aria-hidden="true" className="user secret icon" />
                    Following
                    </Link>
                <Link to={'/watchlist/'} className="item" onClick={visible ? hideSidebar : () => undefined}>
                    <i aria-hidden="true" className="eye icon" />
                    Watchlist
                    </Link>
                <a className="item" onClick={signOutUser}>
                    <i aria-hidden="true" className="sign-out icon" />
                    Logout
                    </a>
            </div>);
    }
    return (
        <div>
            <a className="item" onClick={signInCreateUser.bind(this, { prompt: true })}>
                <i aria-hidden="true" className="sign-in icon" />
                Login
            </a>
        </div>);
}

export default SideBar;


// WEBPACK FOOTER //
// ./src/components/SideBar.tsx